import React from "react";
import ReactDOM from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import store, { persistor } from "./app/store.ts";
import CustomSpinner from "./components/spinner/CustomSpinner.tsx";
import { enableMocking } from "./app/mocks/enableMocking.ts";
import App from "./App.tsx";
import "./i18n/i18n";
import "./styles/main.scss";

enableMocking();

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={<CustomSpinner isFullScreen={true} hideTextTitle={true} />} persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    </React.StrictMode>
);
